<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="cashFlowViewIndexFilters"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    :itemClass="itemClasses"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"
  >
    <template slot="new" v-if="$can('create', $router.currentRoute.name)">
      <New
        @entry-created="entryCreated"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="filterSwitch">
        <v-checkbox style="padding: 4px 16px;" label="Exibir apenas os pendentes" v-model="filterSwitch"></v-checkbox>
    </template>

    <template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" slot-scope="{ item }" v-if="$can('update', $router.currentRoute.name)">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
      <!-- :readOnly="!item.canBeDeleted" -->
    </template>

    <template slot="delete" slot-scope="{ item }" v-if="$can('delete', $router.currentRoute.name)">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        @entry-canceled="loadServerEntries()"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="tableFooter">
      <tr class="d-none d-md-table-row">
        <td colspan="4" class="text-right"><strong class="title mx-3">Total: </strong></td>
        <td colspan="1" class="text-left title"><strong>{{ this.cashOutflowsTotalPrice | formatCurrency }}</strong></td>
        <td colspan="1" class="text-left title"><strong>{{ this.cashOutflowsTotalPaidAmount | formatCurrency }}</strong></td>
        <td colspan="2" class="text-left title"><strong>{{ this.cashOutflowsTotalUnpaidAmount | formatCurrency }}</strong></td>
      </tr>

      <!-- for mobile only -->
      <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Total das Contas</div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.cashOutflowsTotalPrice | formatCurrency }}</strong></div>
        </td>
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Total Pago</div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.cashOutflowsTotalPaidAmount | formatCurrency }}</strong></div>
        </td>
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Total Pendente</div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.cashOutflowsTotalUnpaidAmount | formatCurrency }}</strong></div>
        </td>
      </tr>
    </template>

  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      cashFlowViewIndexFilters: [],
      loading: true,
      pageLoading: false,
      totalItems: 0,
      cashOutflowsTotalPrice: 0,
      cashOutflowsTotalPaidAmount: 0,
      cashOutflowsTotalUnpaidAmount: 0,
      filterSwitch: true,
      tableHeaders: [
        { text: "Código", align: "left", sortable: true, value: "code", type_test: "string"},
        { text: "Fornecedor", align: "left", sortable: true, value: "supplier.name" },
        { text: "Plano de Contas", align: "left", sortable: true, value: "chartName" },
        { text: "Data de Faturamento", align: "left", sortable: true, value: "billDate" },
        { text: "Valor", align: "left", sortable: false, value: "totalPrice"},
        { text: "Pago", align: "left", sortable: false, value: "totalPaidAmount"},
        { text: "Pendente", align: "left", sortable: false, value: "unpaidAmount"},
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      maskFields: [
        { field: 'billDate', mask: 'date' },
        { field: 'totalPrice', mask: 'currency'},
        { field: 'totalPaidAmount', mask: 'currency' },
        { field: 'unpaidAmount', mask: 'currency'},
      ],
      infoHeaders: [
        { field: 'totalPrice', info: 'Valor da conta a pagar (capital)' },
        { field: 'totalPaidAmount', info: 'Valor já pago da conta incluindo juros, multas e descontos' },
        { field: 'unpaidAmount', info: 'Valor restante a ser pago (capital)' },
      ],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["code"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [],
      typeOperators: [],
      serverFields: [],
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Conta a Pagar"
    },
    modelNamePlural: {
      type: String,
      default: "Contas a Pagar"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  created() {
    // this.loadServerEntries();
  },
  mounted() {

  },
  watch: {
    "filterSwitch": function(item){
      // console.log(item);
      this.loadServerEntries();
    },
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_CASH_OUTFLOWS,
          variables: {
            input: {
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.value),
              filters: this.filters
            },
            onlyNotPaid: this.filterSwitch,
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // console.log("response", response);
          this.cashFlowViewIndexFilters = response.data.accountContext.cashOutflowsIndex.cashFlowViewIndexFilters;
          
          this.cashOutflowsTotalPrice = response.data.accountContext.cashOutflowsIndex.cashOutflowsTotalPrice;
          this.cashOutflowsTotalPaidAmount = response.data.accountContext.cashOutflowsIndex.cashOutflowsTotalPaidAmount;
          this.cashOutflowsTotalUnpaidAmount = response.data.accountContext.cashOutflowsIndex.cashOutflowsTotalUnpaidAmount;
          this.totalItems = response.data.accountContext.cashOutflowsIndex.count;
          this.typeOperators = response.data.accountContext.cashOutflowsIndex.typeOperators;
          this.serverFields = response.data.accountContext.cashOutflowsIndex.serverFields;
          // console.log("All cashOutflowsIndex", this.cashFlowViewIndexFilters, this.totalItems);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    itemClasses: function(item) {
      if (item.unpaidAmount > 0) {
        return "pending_item";
      }
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    }
  }
};

const LOAD_ALL_CASH_OUTFLOWS = gql `
  query($input: IndexInputObject!, $onlyNotPaid: Boolean!) {
    accountContext {
      cashOutflowsIndex(input: $input, onlyNotPaid: $onlyNotPaid) {
        count
        cashOutflowsTotalPrice
        cashOutflowsTotalPaidAmount
        cashOutflowsTotalUnpaidAmount
        cashFlowViewIndexFilters {
          id
          code
          chartName
          supplierId
          supplier {
            id
            name
          }
          billDate
          totalPrice
          paidAmount
          totalPaidAmount
          unpaidAmount
          canBeDeleted
          undeletabilityReasons
        }
        typeOperators
        serverFields
      }
    }
  }
`;

</script>

<style scoped>
  ::v-deep .pending_item {
    color: red;
  }

</style>
